import React, {Component, ReactNode} from "react";
import projectVersionService from "../../service/projectVersionService";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from "material-ui/Table";
import {ProjectVersion} from "../../domain/project/projectVersionDomain";

interface Props {
  subCriterionCode : string;
  projectVersionId : number;
}

interface AreaInfo {
  areaId : number;
  areaLabel : string;
  areaM2 : number;
}

interface State {
  areas? : AreaInfo[];
  projectVersion? : ProjectVersion
}

export default class SubCriterionAreaList extends Component<Props, State> {

  private showExtCreditsSubCriteria : string[] = ['EXTMB', 'EXTMA', 'EXTPR'];
  private bdSubCriterionCode = 'EXTMB';
  private abSubCriterionCode = 'EXTMA';
  private extCredits = 10;

  constructor() {
    super();
    this.renderTableBody.bind(this);
  }

  componentDidMount(): void {
    const {projectVersionId, subCriterionCode} = this.props;
    projectVersionService.getProjectVersionAreaBySubCriterionCode(projectVersionId, subCriterionCode)
      .then(response => {
        const areaInfo : AreaInfo[] = [];
        Object.values(response).forEach((entry : any) => {
          const newInfo : AreaInfo = {areaId: entry.id, areaLabel: entry.area.label, areaM2 : entry.m2};
          areaInfo.push(newInfo);
        });
        areaInfo.sort((a, b) => (a.areaId - b.areaId));

        this.setState({areas : areaInfo, projectVersion : projectVersionService.projectVersion});
      });
  }

  render(): JSX.Element | false | null {
    const state : State = this.state;
    return (state && state.areas && state.areas.length > 0) ? this.renderTable() : null;
  }

  renderTable = () : JSX.Element => {
    return (
      <Table selectable={false}>
        <TableHeader displaySelectAll={false} adjustForCheckbox={false} key={0}>
          {this.renderTableHeader()}
        </TableHeader>
        <TableBody displayRowCheckbox={false}>
          {this.renderTableBody(this.state.areas)}
        </TableBody>
      </Table>
    );
  };

  renderTableHeader = () : ReactNode => {
    const {subCriterionCode} = this.props;
    const header = this.showExtCreditsSubCriteria.includes(subCriterionCode) ?
      this.renderExpCriterionTableHeader() : this.renderDefaultTableHeader();

    return header;
  };

  renderExpCriterionTableHeader = () : ReactNode => (
    <TableRow>
      <TableHeaderColumn style={{textAlign: 'center', width: '60%'}}>Název plochy</TableHeaderColumn>
      <TableHeaderColumn style={{textAlign: 'center', width: '20%'}}>Výměra</TableHeaderColumn>
      <TableHeaderColumn style={{textAlign: 'center', width: '20%'}}>Kredity</TableHeaderColumn>
    </TableRow>
  );

  renderDefaultTableHeader = () : ReactNode => (
    <TableRow>
      <TableHeaderColumn style={{textAlign: 'center', width: '80%'}}>Název plochy</TableHeaderColumn>
      <TableHeaderColumn style={{textAlign: 'center', width: '20%'}}>Výměra</TableHeaderColumn>
    </TableRow>
  );

  renderTableBody = (areas : AreaInfo[]) : ReactNode => {
    const {subCriterionCode} = this.props;
    const body = this.showExtCreditsSubCriteria.includes(subCriterionCode) ?
      this.renderExpCriterionTableBody(areas) : this.renderDefaultTableBody(areas);

    return body;
  };

  renderExpCriterionTableBody = (areas : AreaInfo[]) : ReactNode => {
    const {subCriterionCode} = this.props;
    const {projectVersion} = this.state;

    if (subCriterionCode === this.bdSubCriterionCode) {
      let minimalM2 = projectVersion.project.countOfHousingUnits * 0.5;
      minimalM2 = (minimalM2 < 10) ? 10 : minimalM2;
      areas = areas.filter(area => (area.areaM2 >= minimalM2));
    }
    else if (subCriterionCode === this.abSubCriterionCode) {
      let minimalM2 = (Number(projectVersion.project.cadastralParcelNumber) <= 10000) ?
        (10 + 0.002 * Number(projectVersion.project.cadastralParcelNumber)) :
        (30);
      areas = areas.filter(area => (area.areaM2 >= minimalM2));
    }

    return areas.map(areaInfo => (
      <TableRow key={areaInfo.areaId}>
        <TableRowColumn><div style={{width: '60%'}}><p style={{overflow: 'auto'}}>{areaInfo.areaLabel}</p></div></TableRowColumn>
        <TableRowColumn style={{textAlign: 'center', width: '20%'}}>{areaInfo.areaM2}</TableRowColumn>
        <TableRowColumn style={{textAlign: 'center', width: '20%'}}>{this.extCredits}</TableRowColumn>
      </TableRow>
    ));
  };

  renderDefaultTableBody = (areas : AreaInfo[]) : ReactNode => {
    return areas.map(areaInfo => (
      <TableRow key={areaInfo.areaId}>
        <TableRowColumn><div style={{width: '80%'}}><p style={{overflow: 'auto'}}>{areaInfo.areaLabel}</p></div></TableRowColumn>
        <TableRowColumn style={{textAlign: 'center', width: '20%'}}>{areaInfo.areaM2}</TableRowColumn>
      </TableRow>
    ));
  }

}



// WEBPACK FOOTER //
// ./src/sbtool/page/project/subCriterionAreaList.tsx